import { resetBootstrapSections } from '../flows/hydratorRegistry'
import { workspacePreferencesService } from '../service/WorkspacePreferencesService'
import { useAccountStore } from '../stores/accountStore'
import { useSessionStore } from '../stores/sessionStore'
import { useWorkspaceStore } from '../stores/workspaceStore'

import { registerSessionReset } from '@/features/auth'

/** Register module 07's logout reset with auth's feature-owned reset registry. Live tenant data is
 *  cleared; validated account/workspace selection history remains for the next login. */
export function registerAccountSessionReset(): () => void {
  const account = useAccountStore()
  const session = useSessionStore()
  const workspace = useWorkspaceStore()

  return registerSessionReset(() => {
    // Registered feature writers own their state, but 07 owns the dispatch registry. Reset every
    // descriptor on logout so a degraded next-account boot can never retain prior-tenant data.
    resetBootstrapSections()
    workspacePreferencesService.clear()
    session.reset()
    account.resetState()
    workspace.resetState()
  })
}
